module.exports = __webpack_public_path__ + "img/autokast_svalbard.46a829c9.jpg";